export default {
  Onbekend: 0,
  Manueel: 1,
  Itsme: 2,
  XeriusAccount: 3
};
